import { useContext } from "react";
import { SavedCoursesContext } from "../SavedCoursesContext";
export var useSavedCoursesContext = function useSavedCoursesContext() {
  var context = useContext(SavedCoursesContext);
  if (context === undefined) {
    throw new Error('useSavedCoursesContext must be used within a SavedCoursesProvider');
  }
  return context;
};